var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPhaseIconWithoutFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6457_182834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 7C4.60444 7 4.21776 6.8827 3.88886 6.66294C3.55996 6.44318 3.30362 6.13082 3.15224 5.76537C3.00087 5.39992 2.96126 4.99778 3.03843 4.60982C3.1156 4.22186 3.30608 3.86549 3.58579 3.58579C3.86549 3.30608 4.22186 3.1156 4.60982 3.03843C4.99778 2.96126 5.39992 3.00087 5.76537 3.15224C6.13082 3.30362 6.44318 3.55996 6.66294 3.88886C6.8827 4.21776 7 4.60444 7 5C6.99941 5.53025 6.7885 6.03861 6.41356 6.41356C6.03861 6.7885 5.53025 6.99941 5 7ZM5 4C4.80227 3.9998 4.60892 4.05823 4.44439 4.16789C4.27986 4.27756 4.15153 4.43354 4.07562 4.61612C3.99972 4.7987 3.97964 4.99968 4.01794 5.19367C4.05623 5.38766 4.15117 5.56594 4.29077 5.70598C4.43036 5.84602 4.60833 5.94153 4.8022 5.98044C4.99606 6.01936 5.19711 5.99993 5.37993 5.92461C5.56275 5.84928 5.71914 5.72146 5.82933 5.55727C5.93952 5.39309 5.99857 5.19993 5.999 5.0022C5.99932 4.73686 5.89427 4.48224 5.70695 4.29432C5.51962 4.10639 5.26534 4.00053 5 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05368 3.74501L10.993 3.57194C11.2581 3.56731 11.5143 3.66819 11.705 3.8524L15.2807 7.30534C15.4714 7.48958 15.5812 7.74205 15.5858 8.00723C15.5905 8.27241 15.4896 8.52856 15.3053 8.71934L11.8524 12.2949C11.6682 12.4857 11.4157 12.5955 11.1506 12.6001L1.21132 12.774C0.946151 12.7786 0.690025 12.6776 0.499253 12.4934C0.30848 12.3092 0.198679 12.0567 0.193991 11.7916L0.0712583 4.76226C0.0667292 4.49711 0.167666 4.241 0.351885 4.05024C0.536103 3.85948 0.788529 3.74966 1.05368 3.74494L1.05368 3.74501ZM14.586 8.02468L11.0103 4.57164L1.07124 4.74495L1.1939 11.774L11.133 11.6004L14.586 8.02468Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6457_182834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPhaseIconWithoutFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phase-icon-without-fill.4ea45060adf91da342a78ae7e381a429.svg";